const CostCenter = () => import('./CostCenter.vue')

const List = () => import('./pages/List.vue')
const Create = () => import('./pages/Create.vue')
const Edit = () => import('./pages/Edit.vue')

const routes = {
  component: CostCenter,
  path: '/centro-de-custos',
  meta: {
    label: 'Centro de Custos'
  },
  children: [
    {
      path: '',
      component: List,
      name: 'costCentersList',
      meta: {
        label: 'Gerenciar Centro de Custos',
        requiredPermission: {resource: 'costCenter', value: 'view'}
      }
    },
    {
      path: 'cadastro',
      component: Create,
      name: 'costCenterCreate',
      meta: {
        hidden: true,
        label: 'Cadastrar',
        requiredPermission: {resource: 'costCenter', value: 'manage'}
      }
    },
    {
      path: 'atualizar/:id',
      component: Edit,
      name: 'costCenterEdit',
      meta: {
        hidden: true,
        label: 'Atualizar',
        requiredPermission: {resource: 'costCenter', value: 'manage'}
      }
    }
  ]
}

export default routes



// WEBPACK FOOTER //
// ./src/pages/cost-center/routes.js